import type { ReservationSlotTemplateRepository } from './ports/ReservationSlotTemplateRepository';

/**
 * 解放枠テンプレートを削除するUseCase
 *
 * @param {ReservationSlotTemplateRepository} repository - Repository実装（DI）
 * @param {string} id - 削除対象のテンプレートID
 * @returns {Promise<void>}
 * @throws {Error} 基本設定・個別上書きから参照中の場合など
 */
export async function deleteTemplate(
  repository: ReservationSlotTemplateRepository,
  id: string
): Promise<void> {
  await repository.delete(id);
}
